import React, { Component  } from 'react'
import "./FilterPutterCategory.css"

class FilterPutterCategory extends Component {

    render() {
        return (
            <div className="filter-tabs-list">
                <ul>
                    <li className={"tab-section "+ (this.props.category === "all" ? "selected" : "")} onClick={() => this.props.onClick('all')}>
                        <span className="tab-header">Customize your putter</span>
                        <span className="tab-text">Customize your putter and send it to Scotty&#8217;s Custom Shop</span>
                    </li>
                    <li className={"tab-section "+ (this.props.category === "buy" ? "selected" : "")} onClick={() => this.props.onClick('buy')}>
                        <span className="tab-header"><span className="buy-new">New</span>Buy Custom Putter</span>
                        <span className="tab-text">Buy and Customize an Exclusive Custom Shop Putter</span>
                    </li>
                </ul>
            </div>
        );
    }
}

export default FilterPutterCategory;